'use strict';
const angular = require('angular');
import AssistantsController from './assistants.controller';
import routes from './assistants.routes';

export default angular.module('nomasvelloDashboardApp.assistants', [])
    .config(routes)
    .controller('AssistantsController', AssistantsController)
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/assistants/index.ts